import React, { ComponentPropsWithoutRef } from 'react';
import { default as MuiTooltip, TooltipProps as MuiTooltipProps } from '@mui/material/Tooltip';
import { BpDesignSystem } from '../../types';
import { Box } from '../Box/Box';

export type TooltipProps = BpDesignSystem.PropsWithChildren<
  Omit<MuiTooltipProps, 'title' | 'children'> & {
    disabled?: boolean;
    title?: React.ReactNode;
    variant?: 'light' | 'dark';
    tooltipClassName?: string;
    tooltipTargetProps?: ComponentPropsWithoutRef<'span'> & { dataTest?: string };
  }
>;

export const shouldEnableTooltip = (el: HTMLElement | null): boolean => (el ? el.scrollWidth > el.clientWidth : false);

export const Tooltip: React.FC<TooltipProps> = (props) => {
  const {
    dataTest,
    title,
    children,
    disabled,
    tooltipTargetProps,
    className,
    tooltipClassName,
    slotProps,
    variant = 'dark',
    ...rest
  } = props;

  if (disabled || !title) {
    return children;
  }

  return (
    <MuiTooltip
      data-test={dataTest}
      slotProps={slotProps}
      data-variant={variant}
      classes={{ tooltip: `${className ?? ''} variant-${variant}` }}
      className={tooltipClassName}
      enterDelay={300}
      title={title}
      placement="top"
      {...rest}
    >
      <Box component="span" {...tooltipTargetProps}>
        {children}
      </Box>
    </MuiTooltip>
  );
};
